import { BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import { AlignWord } from './lista-styled';
import { dataFrases } from '../../../utils/frases-suporte';

function Lista({ question }) {
  const data = dataFrases.find(({ id }) => id === question);

  return (
    <div>
      {data.frases.map((frase) => (
        <AlignWord key={frase}>
          <div
            style={{
              background: '#394D60',
              borderRadius: '50%',
              marginTop: 8,
              padding: '1px 1px',
              width: 7,
              height: 7,
            }}
          ></div>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae30}>
            {frase}
          </BaSeParagraph>
        </AlignWord>
      ))}
    </div>
  );
}

export default Lista;
